import { Record } from '../transit'

const Group = Record({
  id: '',
  name: '',
  teacher: '',
  students: [],
}, 'group')

export default Group



// WEBPACK FOOTER //
// ./src/common/groups/Group.js